const actionTypes = {
  // Auth
  IS_AUTHENTICATED: "IS_AUTHENTICATED",
  GET_ROLE: "GET_ROLE",
  AUTH_START: "AUTH_START",
  AUTH_SUCCESS: "AUTH_SUCCESS",
  AUTH_FAIL: "AUTH_FAIL",
  CLEAR_AUTH_ERROR: "CLEAR_AUTH_ERROR",
  CLEAR_AUTH_SUCCESS: "CLEAR_AUTH_SUCCESS",
  SET_USER: "SET_USER",
  SIGN_OUT: "SIGN_OUT",
  LOGOUT_START: "LOGOUT_START",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
  LOGOUT_FAIL: "LOGOUT_FAIL",
  UPDATE_RATING: "UPDATE_RATING",
  CLEAR_AUTH_REDUCER_STATE: "CLEAR_AUTH_REDUCER_STATE",
  SET_TEACHER_MESSAGE: "SET_TEACHER_MESSAGE",
  // TEACHER

  CLEAR_TEACHER_ERROR: "CLEAR_TEACHER_ERROR",
  UPDATE_STUDENT: "UPDATE_STUDENT",
  ADD_STUDENT: "ADD_STUDENT",
  DELETE_STUDENT: "DELETE_STUDENT",
  GET_STUDENTS: "GET_STUDENTS",
  GET_TASKS: "GET_TASKS",
  REMOVE_TASK: "REMOVE_TASK",
  CREATE_TASK: "CREATE_TASK",
  GET_STUDENT_PERFORMANCE: "GET_STUDENT_PERFORMANCE",
  GET_STUDENT_TASK_STATUS: "GET_STUDENT_TASK_STATUS",
  TEACHER_REQUEST_START: "TEACHER_REQUEST_START",
  TEACHER_REQUEST_SUCCESS: "TEACHER_REQUEST_SUCCESS",
  TEACHER_REQUEST_FAIL: "TEACHER_REQUEST_FAIL",
  FETCH_PIECES: "FETCH_PIECE",
  UPDATE_PIECE_STATUS: "UPDATE_PIECE_STATUS",
  DELETE_PIECE: "DELETE_PIECE",
  CLEAR_TEACHER_SUCCESS: "CLEAR_TEACHER_SUCCESS",
  ON_TEACHER_SCREEN_NAVIGATION: "ON_TEACHER_SCREEN_NAVIGATION",
  CLEAR_TEACHER_REDUCER_STATE: "CLEAR_TEACHER_REDUCER_STATE",
  CREATE_SESSION: "CREATE_SESSION",
  FETCH_SESSION: "FETCH_SESSION",
  REMOVE_SESSION: "REMOVE_SESSION",
  SELECT_STUDENT: "SELECT_STUDENT",
  UPDATING_SESSION: "UPDATING_SESSION",
  CHANGE_STUDENT_MESSAGE: "CHANGE_STUDENT_MESSAGE",
  SET_CURRENT_STUDENT_REPORT: "SET_CURRENT_STUDENT_REPORT",
  // ADMIN

  CLEAR_ADMIN_ERROR: "CLEAR_ADMIN_ERROR",
  ADD_TEACHER: "ADD_TEACHER",
  UPDATE_TEACHER: "UPDATE_TEACHER",
  DELETE_TEACHER: "DELETE_TEACHER",
  GET_TEACHERS: "GET_TEACHERS",
  ADMIN_REQUEST_START: "ADMIN_REQUEST_START",
  ADMIN_REQUEST_SUCCESS: "ADMIN_REQUEST_SUCCESS",
  ADMIN_REQUEST_FAIL: "ADMIN_REQUEST_FAIL",
  CLEAR_ADMIN_SUCCESS: "CLEAR_ADMIN_SUCCESS",
  GET_CUSTOM_MESSAGES: "GET_CUSTOM_MESSAGES",
  REMOVE_RANDOM_MESSAGE: "REMOVE_RANDOM_MESSAGE",
  CLEAR_ADMIN_REDUCER_STATE: "CLEAR_ADMIN_REDUCER_STATE",
  UPDATE_TEACHER_MESSAGE: "UPDATE_TEACHER_MESSAGE",
  OVERALL_PERFORMANCE: "OVERALL_PERFORMANCE",
};

export default actionTypes;
